export var NO_SCENARIO_FOUND = 'NO_SCENARIO_FOUND';
export var SSR_HOST = 'www.wix.com';
export var SSR_PROTOCOL = 'http';
export var ORIGINAL_URL_HEADER = 'x-wix-metro-original-url';
export var ORIGINAL_HOST_HEADER = 'x-wix-metro-original-host';
export var ORIGINAL_PROTOCOL_HEADER = 'x-wix-metro-original-protocol';
//# sourceMappingURL=constants.js.map